import { render, staticRenderFns } from "./CourseVideoPlaceholderOverlay.vue?vue&type=template&id=3faea352&scoped=true"
import script from "./CourseVideoPlaceholderOverlay.vue?vue&type=script&lang=js"
export * from "./CourseVideoPlaceholderOverlay.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoPlaceholderOverlay.vue?vue&type=style&index=0&id=3faea352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faea352",
  null
  
)

export default component.exports